/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useState } from "react";
import CenterModal from "./CenterModal";

const ModalDialog = ({
  text,
  className,
  textStyle,
  image,
  inline,
  scale="1.1", 
  size="md",
  hideCard = false,
  children
}) => {
  // state
  const [isDisplayed, setDisplayed] = useState(false);

  // handlers
  const toggleDisplayed = () => {
    setDisplayed(!isDisplayed);
  };

  return (
    <>
      {text && <span className={className} style={textStyle} onClick={toggleDisplayed}>{text}</span>}
      {image && (
        <div
          className={`help-icon ${inline ? "p-1 d-inline-block" : ""}`}
          onClick={toggleDisplayed}
          style={{ cursor: "pointer", fontSize: `${scale}rem` }}
        >
          <i className={image} />
        </div>
      )}
      <CenterModal
        className={hideCard ? "modal-card-hidden" : ""}
        isOpen={isDisplayed}
        toggle={toggleDisplayed} size={size}
      >
        <div className="mt-3">
          {children}
        </div>
      </CenterModal>
    </>
  );
};

export default ModalDialog;
